import { supabase } from "./supabase-client-conf";
import { errorMessage } from "../../scripts/errorMessage";

// Función para enviar los datos a Supabase
export async function storageToSupabase() {
    let finalEndTime; 
    if (sessionStorage.getItem('endTime')){
        finalEndTime = sessionStorage.getItem('endTime')
    } else finalEndTime = null;

    try {
        // Insertar los datos en la tabla orders
        const { error } = await supabase
            .from('orders')
            .insert({
                name: sessionStorage.getItem('name'),
                surname: sessionStorage.getItem('surname'),
                title: sessionStorage.getItem('title'),
                email: sessionStorage.getItem('email'),
                country: sessionStorage.getItem('country'),
                phone: sessionStorage.getItem('phone'),
                date: sessionStorage.getItem('date'),
                starttime: sessionStorage.getItem('startTime'),
                endtime: finalEndTime,
                pickupcity: sessionStorage.getItem('pickupCity'),
                pickupsite: sessionStorage.getItem('pickupSite'),
                classe: sessionStorage.getItem('classE'),
                classs: sessionStorage.getItem('classS'),
                classv: sessionStorage.getItem('classV'),
                classsprinter: sessionStorage.getItem('classSprinter'), 
                children: sessionStorage.getItem('children'),
                otherneeds: sessionStorage.getItem('otherNeeds'),
                consent: sessionStorage.getItem('consent')
            });

        if (error) {
            console.error('Error al insertar datos:', error.message);
            errorMessage('There was an error saving the data. Please try again.');
        }
    } catch (error) {
        console.error('Error al comunicarse con Supabase:', error);
        errorMessage('There was an error saving the data. Please try again.');
    }
}